// extracted by mini-css-extract-plugin
export var fileUpload = "_jr-1";
export var modalButton = "_jr-0";